import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { format as dateFnsFormat } from "date-fns"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export function getValidDate(dateValue, fallback = new Date()) {
  if (!dateValue) return fallback;

  const date = new Date(dateValue);
  return isNaN(date.getTime()) ? fallback : date;
}

export function formatApplicationDate(application, formatStr = 'MMM d, yyyy') {
  try {
    const dateValue = application.created_at || application.submission_date;
    if (!dateValue) return 'N/A';

    const date = getValidDate(dateValue);
    return dateFnsFormat(date, formatStr);
  } catch (error) {
    console.warn('Error formatting date:', error);
    return 'N/A';
  }
} 